var $gXNCa$reduxbundler = require("redux-bundler");
var $gXNCa$reactjsxruntime = require("react/jsx-runtime");
var $gXNCa$reduxbundlerreact = require("redux-bundler-react");
require("react");
var $gXNCa$reactbootstrap = require("react-bootstrap");


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

$parcel$export(module.exports, "bundles", () => $da1b3c90c1ec2a9d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "suggestions", () => $f9636d502f8281bf$export$2e2bcd8739ae039);

// const API = 'http://brie6:8081/search_api';
// const API = 'http://127.0.0.1:5000/search_api';
// const API = '/search_api';
const $da1b3c90c1ec2a9d$var$API = "https://www.sorghumbase.org/search_api";
const $da1b3c90c1ec2a9d$var$sorghumPosts = (0, $gXNCa$reduxbundler.createAsyncResourceBundle)({
    name: "sorghumPosts",
    actionBaseType: "SORGHUM_POSTS",
    persist: false,
    getPromise: ({ store: store })=>fetch(`${$da1b3c90c1ec2a9d$var$API}/posts?${store.selectQueryString()}&rows=${store.selectRows()["Posts"] * 3}`).then((res)=>res.json())
});
$da1b3c90c1ec2a9d$var$sorghumPosts.reactSorghumPosts = (0, $gXNCa$reduxbundler.createSelector)("selectSorghumPostsShouldUpdate", "selectQueryString", "selectPathname", (shouldUpdate, queryString, path)=>{
    if (shouldUpdate && queryString && (path === "/search" || path === "/search.html")) return {
        actionCreator: "doFetchSorghumPosts"
    };
});
// const sorghumProjects = createAsyncResourceBundle({
//   name: 'sorghumProjects',
//   actionBaseType: 'SORGHUM_PROJECTS',
//   persist: false,
//   getPromise: ({store}) =>
//     fetch(`${API}/project?${store.selectQueryString()}&rows=${store.selectRows()['Projects'] * 3}`)
//       .then(res => res.json())
// });
//
// sorghumProjects.reactSorghumProjects = createSelector(
//   'selectSorghumProjectsShouldUpdate',
//   'selectQueryString',
//   'selectPathname',
//   (shouldUpdate, queryString, path) => {
//     if (shouldUpdate && queryString && (path === '/search' || path === '/search.html')) {
//       return {actionCreator: 'doFetchSorghumProjects'}
//     }
//   }
// );
//
// const sorghumLinks = createAsyncResourceBundle({
//   name: 'sorghumLinks',
//   actionBaseType: 'SORGHUM_LINKS',
//   persist: false,
//   getPromise: ({store}) =>
//     fetch(`${API}/resource-link?${store.selectQueryString()}&rows=${store.selectRows()['Links'] * 3}`)
//       .then(res => res.json())
// });
//
// sorghumLinks.reactSorghumLinks = createSelector(
//   'selectSorghumLinksShouldUpdate',
//   'selectQueryString',
//   'selectPathname',
//   (shouldUpdate, queryString, path) => {
//     if (shouldUpdate && queryString && (path === '/search' || path === '/search.html')) {
//       return {actionCreator: 'doFetchSorghumLinks'}
//     }
//   }
// );
//
// const sorghumPeople = createAsyncResourceBundle({
//   name: 'sorghumPeople',
//   actionBaseType: 'SORGHUM_PEOPLE',
//   persist: false,
//   getPromise: ({store}) =>
//     fetch(`${API}/users?${store.selectQueryString()}&rows=${store.selectRows()['People'] * 3}`)
//       .then(res => res.json())
// });
//
// sorghumPeople.reactSorghumPeople = createSelector(
//   'selectSorghumPeopleShouldUpdate',
//   'selectQueryString',
//   'selectPathname',
//   (shouldUpdate, queryString, path) => {
//     if (shouldUpdate && queryString && (path === '/search' || path === '/search.html')) {
//       return {actionCreator: 'doFetchSorghumPeople'}
//     }
//   }
// );
const $da1b3c90c1ec2a9d$var$sorghumEvents = (0, $gXNCa$reduxbundler.createAsyncResourceBundle)({
    name: "sorghumEvents",
    actionBaseType: "SORGHUM_EVENTS",
    persist: false,
    getPromise: ({ store: store })=>fetch(`${$da1b3c90c1ec2a9d$var$API}/event?${store.selectQueryString()}&rows=${store.selectRows()["Events"] * 3}`).then((res)=>res.json())
});
$da1b3c90c1ec2a9d$var$sorghumEvents.reactSorghumEvents = (0, $gXNCa$reduxbundler.createSelector)("selectSorghumEventsShouldUpdate", "selectQueryString", "selectPathname", (shouldUpdate, queryString, path)=>{
    if (shouldUpdate && queryString && (path === "/search" || path === "/search.html")) return {
        actionCreator: "doFetchSorghumEvents"
    };
});
const $da1b3c90c1ec2a9d$var$sorghumPapers = (0, $gXNCa$reduxbundler.createAsyncResourceBundle)({
    name: "sorghumPapers",
    actionBaseType: "SORGHUM_PAPERS",
    persist: false,
    getPromise: ({ store: store })=>fetch(`${$da1b3c90c1ec2a9d$var$API}/scientific_paper?${store.selectQueryString()}&rows=${store.selectRows()["Papers"] * 3}`).then((res)=>res.json())
});
$da1b3c90c1ec2a9d$var$sorghumPapers.reactSorghumPapers = (0, $gXNCa$reduxbundler.createSelector)("selectSorghumPapersShouldUpdate", "selectQueryString", "selectPathname", (shouldUpdate, queryString, path)=>{
    if (shouldUpdate && queryString && (path === "/search" || path === "/search.html")) return {
        actionCreator: "doFetchSorghumPapers"
    };
});
const $da1b3c90c1ec2a9d$var$sorghumPostsSuggestions = (0, $gXNCa$reduxbundler.createAsyncResourceBundle)({
    name: "sorghumPostsSuggestions",
    actionBaseType: "SORGHUM_POSTS_SUGGESTIONS",
    persist: false,
    getPromise: ({ store: store })=>fetch(`${$da1b3c90c1ec2a9d$var$API}/posts?q=${store.selectSuggestionsQuery()}&rows=100`).then((res)=>res.json()).then((posts)=>{
            const q = store.selectSuggestionsQuery();
            return q === posts.q ? posts : store.selectPostsSuggestions();
        })
});
$da1b3c90c1ec2a9d$var$sorghumPostsSuggestions.reactSorghumPostsSuggestions = (0, $gXNCa$reduxbundler.createSelector)("selectSorghumPostsSuggestionsShouldUpdate", "selectSuggestionsQuery", (shouldUpdate, queryString)=>{
    if (shouldUpdate && queryString.length > 1) return {
        actionCreator: "doFetchSorghumPostsSuggestions"
    };
});
const $da1b3c90c1ec2a9d$var$sorghumProjectsSuggestions = (0, $gXNCa$reduxbundler.createAsyncResourceBundle)({
    name: "sorghumProjectsSuggestions",
    actionBaseType: "SORGHUM_PROJECTS_SUGGESTIONS",
    persist: false,
    getPromise: ({ store: store })=>fetch(`${$da1b3c90c1ec2a9d$var$API}/project?q=${store.selectSuggestionsQuery()}&rows=100`).then((res)=>res.json())
});
$da1b3c90c1ec2a9d$var$sorghumProjectsSuggestions.reactSorghumProjectsSuggestions = (0, $gXNCa$reduxbundler.createSelector)("selectSorghumProjectsSuggestionsShouldUpdate", "selectSuggestionsQuery", (shouldUpdate, queryString)=>{
    if (shouldUpdate && queryString.length > 1) return {
        actionCreator: "doFetchSorghumProjectsSuggestions"
    };
});
const $da1b3c90c1ec2a9d$var$sorghumAbstractsSuggestions = (0, $gXNCa$reduxbundler.createAsyncResourceBundle)({
    name: "sorghumAbstractsSuggestions",
    actionBaseType: "SORGHUM_ABSTRACTS_SUGGESTIONS",
    persist: false,
    getPromise: ({ store: store })=>fetch(`${$da1b3c90c1ec2a9d$var$API}/conference_abstract?q=${store.selectSuggestionsQuery()}&rows=100`).then((res)=>res.json())
});
$da1b3c90c1ec2a9d$var$sorghumAbstractsSuggestions.reactSorghumAbstractsSuggestions = (0, $gXNCa$reduxbundler.createSelector)("selectSorghumAbstractsSuggestionsShouldUpdate", "selectSuggestionsQuery", (shouldUpdate, queryString)=>{
    if (shouldUpdate && queryString.length > 1) return {
        actionCreator: "doFetchSorghumAbstractsSuggestions"
    };
});
// const sorghumLinksSuggestions = createAsyncResourceBundle({
//   name: 'sorghumLinksSuggestions',
//   actionBaseType: 'SORGHUM_LINKS_SUGGESTIONS',
//   persist: false,
//   getPromise: ({store}) =>
//     fetch(`${API}/resource-link?q=${store.selectSuggestionsQuery()}&rows=100`)
//       .then(res => res.json())
// });
//
// sorghumLinksSuggestions.reactSorghumLinksSuggestions = createSelector(
//   'selectSorghumLinksSuggestionsShouldUpdate',
//   'selectSuggestionsQuery',
//   (shouldUpdate, queryString) => {
//     if (shouldUpdate && queryString.length > 1) {
//       return {actionCreator: 'doFetchSorghumLinksSuggestions'}
//     }
//   }
// );
//
// const sorghumPeopleSuggestions = createAsyncResourceBundle({
//   name: 'sorghumPeopleSuggestions',
//   actionBaseType: 'SORGHUM_PEOPLE_SUGGESTIONS',
//   persist: false,
//   getPromise: ({store}) =>
//     fetch(`${API}/users?q=${store.selectSuggestionsQuery()}&rows=100`)
//       .then(res => res.json())
// });
//
// sorghumPeopleSuggestions.reactSorghumPeopleSuggestions = createSelector(
//   'selectSorghumPeopleSuggestionsShouldUpdate',
//   'selectSuggestionsQuery',
//   (shouldUpdate, queryString) => {
//     if (shouldUpdate && queryString.length > 1) {
//       return {actionCreator: 'doFetchSorghumPeopleSuggestions'}
//     }
//   }
// );
const $da1b3c90c1ec2a9d$var$sorghumEventsSuggestions = (0, $gXNCa$reduxbundler.createAsyncResourceBundle)({
    name: "sorghumEventsSuggestions",
    actionBaseType: "SORGHUM_EVENTS_SUGGESTIONS",
    persist: false,
    getPromise: ({ store: store })=>fetch(`${$da1b3c90c1ec2a9d$var$API}/event?q=${store.selectSuggestionsQuery()}&rows=100`).then((res)=>res.json()).then((events)=>{
            const q = store.selectSuggestionsQuery();
            return q === events.q ? events : store.selectEventsSuggestions();
        }).then((events)=>{
            // filter out past events
            const now = new Date();
            events.docs = events.docs.filter((e)=>new Date(e.start_date) > now);
            events.numFound = events.docs.length;
            return events;
        })
});
$da1b3c90c1ec2a9d$var$sorghumEventsSuggestions.reactSorghumEventsSuggestions = (0, $gXNCa$reduxbundler.createSelector)("selectSorghumEventsSuggestionsShouldUpdate", "selectSuggestionsQuery", (shouldUpdate, queryString)=>{
    if (shouldUpdate && queryString.length > 1) return {
        actionCreator: "doFetchSorghumEventsSuggestions"
    };
});
const $da1b3c90c1ec2a9d$var$sorghumPapersSuggestions = (0, $gXNCa$reduxbundler.createAsyncResourceBundle)({
    name: "sorghumPapersSuggestions",
    actionBaseType: "SORGHUM_PAPERS_SUGGESTIONS",
    persist: false,
    getPromise: ({ store: store })=>fetch(`${$da1b3c90c1ec2a9d$var$API}/scientific_paper?q=${store.selectSuggestionsQuery()}&rows=100`).then((res)=>res.json()).then((papers)=>{
            const q = store.selectSuggestionsQuery();
            return q === papers.q ? papers : store.selectPapersSuggestions();
        })
});
$da1b3c90c1ec2a9d$var$sorghumPapersSuggestions.reactSorghumPapersSuggestions = (0, $gXNCa$reduxbundler.createSelector)("selectSorghumPapersSuggestionsShouldUpdate", "selectSuggestionsQuery", (shouldUpdate, queryString)=>{
    if (shouldUpdate && queryString.length > 1) return {
        actionCreator: "doFetchSorghumPapersSuggestions"
    };
});
const $da1b3c90c1ec2a9d$var$sorghumTags = (0, $gXNCa$reduxbundler.createAsyncResourceBundle)({
    name: "sorghumTags",
    actionBaseType: "SORGHUM_TAGS",
    persist: false,
    getPromise: ({ store: store })=>fetch(`${$da1b3c90c1ec2a9d$var$API}/tags`).then((res)=>res.json())
});
$da1b3c90c1ec2a9d$var$sorghumTags.reactSorghumTags = (0, $gXNCa$reduxbundler.createSelector)("selectSorghumTagsShouldUpdate", (shouldUpdate)=>{
    if (shouldUpdate) return {
        actionCreator: "doFetchSorghumTags"
    };
});
var // sorghumPostsSuggestions.doAcceptPostSuggestion = post => {
//   console.log(post)
// };
//
// sorghumPapersSuggestions.doAcceptPaperSuggestion = paper => {
//   console.log(paper)
// };
// sorghumEventsSuggestions.doAcceptEventSuggestion = event => {
//   console.log(event)
// };
// sorghumLinksSuggestions.doAcceptLinkSuggestion = link => {
//   console.log(link)
// };
// sorghumProjectsSuggestions.doAcceptProjectSuggestion = project => {
//   console.log(project)
// };
$da1b3c90c1ec2a9d$export$2e2bcd8739ae039 = [
    $da1b3c90c1ec2a9d$var$sorghumPosts,
    // sorghumProjects,
    // sorghumLinks,
    // sorghumPeople,
    $da1b3c90c1ec2a9d$var$sorghumEvents,
    $da1b3c90c1ec2a9d$var$sorghumPapers,
    $da1b3c90c1ec2a9d$var$sorghumTags,
    $da1b3c90c1ec2a9d$var$sorghumPostsSuggestions,
    $da1b3c90c1ec2a9d$var$sorghumProjectsSuggestions,
    $da1b3c90c1ec2a9d$var$sorghumAbstractsSuggestions,
    // sorghumLinksSuggestions,
    // sorghumPeopleSuggestions,
    $da1b3c90c1ec2a9d$var$sorghumEventsSuggestions,
    $da1b3c90c1ec2a9d$var$sorghumPapersSuggestions
];






const $f9636d502f8281bf$var$dateOptions = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric"
};
const $f9636d502f8281bf$var$formatDate = (dateString)=>{
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-US", $f9636d502f8281bf$var$dateOptions).format(date);
};
function $f9636d502f8281bf$var$createMarkup(content) {
    return {
        __html: content
    };
}
const $f9636d502f8281bf$var$PostsCmp = ({ sorghumPostsSuggestions: sorghumPostsSuggestions, doAcceptSuggestion: doAcceptSuggestion })=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Row), {
        xs: 1,
        md: 2,
        lg: 4,
        className: "g-4",
        children: sorghumPostsSuggestions && sorghumPostsSuggestions.docs.map((post, idx)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Col), {
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Card), {
                    bg: "light",
                    text: "dark",
                    border: "dark",
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Card).Body, {
                            style: {
                                maxHeight: "20em",
                                overflowY: "scroll"
                            },
                            children: [
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Card).Title, {
                                    dangerouslySetInnerHTML: $f9636d502f8281bf$var$createMarkup(post.title.rendered)
                                }),
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Card).Text, {
                                    dangerouslySetInnerHTML: $f9636d502f8281bf$var$createMarkup(post.excerpt.rendered)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Card).Footer, {
                            children: [
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("small", {
                                    className: "text-muted",
                                    children: $f9636d502f8281bf$var$formatDate(post.date)
                                }),
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("a", {
                                    href: `/post/${post.slug}`,
                                    style: {
                                        float: "right"
                                    },
                                    onClick: doAcceptSuggestion,
                                    children: "Read more"
                                })
                            ]
                        })
                    ]
                }, idx)
            }))
    });
const $f9636d502f8281bf$var$ProjectsCmp = ({ sorghumProjectsSuggestions: sorghumProjectsSuggestions, doAcceptSuggestion: doAcceptSuggestion })=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Row), {
        xs: 1,
        md: 2,
        lg: 4,
        className: "g-4",
        children: sorghumProjectsSuggestions && sorghumProjectsSuggestions.docs.map((project, idx)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Col), {
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Card), {
                    bg: "light",
                    text: "dark",
                    border: "dark",
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Card).Body, {
                            style: {
                                maxHeight: "20em",
                                overflowY: "scroll"
                            },
                            children: [
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Card).Title, {
                                    dangerouslySetInnerHTML: $f9636d502f8281bf$var$createMarkup(project.title.rendered)
                                }),
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Card).Text, {
                                    dangerouslySetInnerHTML: $f9636d502f8281bf$var$createMarkup(project.project_description)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Card).Footer, {
                            children: [
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("small", {
                                    className: "text-muted",
                                    children: [
                                        project.funding_agency,
                                        "-",
                                        project.funding_program,
                                        ":",
                                        project.award_id
                                    ]
                                }),
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("a", {
                                    href: `/project/${project.slug}`,
                                    style: {
                                        float: "right"
                                    },
                                    onClick: doAcceptSuggestion,
                                    children: "Read more"
                                })
                            ]
                        })
                    ]
                }, idx)
            }))
    });
const $f9636d502f8281bf$var$AbstractsCmp = ({ sorghumAbstractsSuggestions: sorghumAbstractsSuggestions, doAcceptSuggestion: doAcceptSuggestion })=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Row), {
        xs: 1,
        md: 2,
        lg: 4,
        className: "g-4",
        children: sorghumAbstractsSuggestions && sorghumAbstractsSuggestions.docs.map((abstract, idx)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Col), {
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Card), {
                    bg: "light",
                    text: "dark",
                    border: "dark",
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Card).Body, {
                            style: {
                                maxHeight: "20em",
                                overflowY: "scroll"
                            },
                            children: [
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Card).Title, {
                                    dangerouslySetInnerHTML: $f9636d502f8281bf$var$createMarkup(abstract.title.rendered)
                                }),
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Card).Text, {
                                    dangerouslySetInnerHTML: $f9636d502f8281bf$var$createMarkup(abstract.content.rendered)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Card).Footer, {
                            children: [
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("small", {
                                    className: "text-muted",
                                    children: [
                                        "SICNA ",
                                        abstract.presentation_type
                                    ]
                                }),
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("a", {
                                    href: `/abstract/${abstract.slug}`,
                                    style: {
                                        float: "right"
                                    },
                                    onClick: doAcceptSuggestion,
                                    children: "Read more"
                                })
                            ]
                        })
                    ]
                }, idx)
            }))
    });
const $f9636d502f8281bf$var$EventsCmp = ({ sorghumEventsSuggestions: sorghumEventsSuggestions, doAcceptSuggestion: doAcceptSuggestion })=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Row), {
        xs: 1,
        md: 2,
        lg: 4,
        className: "g-4",
        children: sorghumEventsSuggestions && sorghumEventsSuggestions.docs.map((event, idx)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Col), {
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Card), {
                    bg: "light",
                    text: "dark",
                    border: "dark",
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Card).Body, {
                            children: [
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Card).Title, {
                                    dangerouslySetInnerHTML: $f9636d502f8281bf$var$createMarkup(event.title.rendered)
                                }),
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Card).Text, {
                                    dangerouslySetInnerHTML: $f9636d502f8281bf$var$createMarkup(event.content.rendered)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Card).Footer, {
                            children: [
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("small", {
                                    className: "text-muted",
                                    children: $f9636d502f8281bf$var$formatDate(event.start_date)
                                }),
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("a", {
                                    href: `/events#${event.id}`,
                                    style: {
                                        float: "right"
                                    },
                                    onClick: doAcceptSuggestion,
                                    children: "Details"
                                })
                            ]
                        })
                    ]
                }, idx)
            }))
    });
// const LinksCmp = ({sorghumLinksSuggestions, doAcceptLinkSuggestion}) => (
//   <div>
//     {sorghumLinksSuggestions && sorghumLinksSuggestions.docs.map((link,idx) =>
//       <Button key={idx}>{link.slug}</Button>
//     )}
//   </div>
// );
// make sure sorghumTags is here
const $f9636d502f8281bf$var$PapersCmp = ({ sorghumPapersSuggestions: sorghumPapersSuggestions, sorghumTags: sorghumTags, doAcceptSuggestion: doAcceptSuggestion })=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Row), {
        xs: 1,
        md: 2,
        lg: 4,
        className: "g-4",
        children: sorghumTags && sorghumPapersSuggestions && sorghumPapersSuggestions.docs.map((paper, idx)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Col), {
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Card), {
                    bg: "light",
                    text: "dark",
                    border: "dark",
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Card).Body, {
                            children: [
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Card).Title, {
                                    dangerouslySetInnerHTML: $f9636d502f8281bf$var$createMarkup(paper.title.rendered)
                                }),
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Card).Text, {
                                    children: [
                                        paper.paper_authors,
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("small", {
                                            children: paper.tags.map((t)=>sorghumTags[t]).join(", ")
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Card).Footer, {
                            children: [
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("small", {
                                    className: "text-muted",
                                    children: $f9636d502f8281bf$var$formatDate(paper.publication_date)
                                }),
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("a", {
                                    href: `/paper/${paper.slug}`,
                                    style: {
                                        float: "right"
                                    },
                                    children: "Read more"
                                })
                            ]
                        })
                    ]
                }, idx)
            }))
    });
const $f9636d502f8281bf$var$Posts = (0, $gXNCa$reduxbundlerreact.connect)("selectSorghumPostsSuggestions", "doAcceptSuggestion", $f9636d502f8281bf$var$PostsCmp);
const $f9636d502f8281bf$var$Projects = (0, $gXNCa$reduxbundlerreact.connect)("selectSorghumProjectsSuggestions", "doAcceptSuggestion", $f9636d502f8281bf$var$ProjectsCmp);
const $f9636d502f8281bf$var$Abstracts = (0, $gXNCa$reduxbundlerreact.connect)("selectSorghumAbstractsSuggestions", "doAcceptSuggestion", $f9636d502f8281bf$var$AbstractsCmp);
const $f9636d502f8281bf$var$Events = (0, $gXNCa$reduxbundlerreact.connect)("selectSorghumEventsSuggestions", "doAcceptSuggestion", $f9636d502f8281bf$var$EventsCmp);
// const Links = connect(
//   'selectSorghumLinksSuggestions',
//   'doAcceptLinkSuggestion',
//   LinksCmp
// );
const $f9636d502f8281bf$var$Papers = (0, $gXNCa$reduxbundlerreact.connect)("selectSorghumPapersSuggestions", "selectSorghumTags", "doAcceptSuggestion", $f9636d502f8281bf$var$PapersCmp);
const $f9636d502f8281bf$var$makeNavItem = (category, results)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Nav).Item, {
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Nav).Link, {
            eventKey: category,
            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "suggestions-tab",
                children: [
                    category,
                    " ",
                    results ? results.numFound : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                        children: "..."
                    })
                ]
            })
        })
    });
const $f9636d502f8281bf$var$status = (results)=>{
    return results ? results.numFound : "...";
};
const $f9636d502f8281bf$var$Suggestions = ({ sorghumPostsSuggestions: sorghumPostsSuggestions, sorghumProjectsSuggestions: sorghumProjectsSuggestions, sorghumEventsSuggestions: sorghumEventsSuggestions, sorghumPapersSuggestions: sorghumPapersSuggestions, sorghumAbstractsSuggestions: sorghumAbstractsSuggestions, sorghumTab: sorghumTab, doChangeSorghumTab: doChangeSorghumTab })=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Tabs), {
        id: "cms-tabs",
        activeKey: sorghumTab,
        onSelect: (k)=>doChangeSorghumTab(k),
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Tab), {
                eventKey: "Posts",
                title: `Posts ${$f9636d502f8281bf$var$status(sorghumPostsSuggestions)}`,
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($f9636d502f8281bf$var$Posts, {})
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Tab), {
                eventKey: "Projects",
                title: `Projects ${$f9636d502f8281bf$var$status(sorghumProjectsSuggestions)}`,
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($f9636d502f8281bf$var$Projects, {})
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Tab), {
                eventKey: "Papers",
                title: `Papers ${$f9636d502f8281bf$var$status(sorghumPapersSuggestions)}`,
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($f9636d502f8281bf$var$Papers, {})
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Tab), {
                eventKey: "Abstracts",
                title: `Conference Abstracts ${$f9636d502f8281bf$var$status(sorghumAbstractsSuggestions)}`,
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($f9636d502f8281bf$var$Abstracts, {})
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Tab), {
                eventKey: "Events",
                title: `Events ${$f9636d502f8281bf$var$status(sorghumEventsSuggestions)}`,
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($f9636d502f8281bf$var$Events, {})
            })
        ]
    });
var $f9636d502f8281bf$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)("selectSorghumPostsSuggestions", "selectSorghumProjectsSuggestions", "selectSorghumEventsSuggestions", "selectSorghumPapersSuggestions", "selectSorghumAbstractsSuggestions", "selectSorghumTab", "doChangeSorghumTab", $f9636d502f8281bf$var$Suggestions);




//# sourceMappingURL=index.js.map
